var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75475 9.34626L7.28759 8.88811L11.2584 4.99383H0V4.35242H11.2584L7.28759 0.45815L7.75475 0L12.5197 4.67313L7.75475 9.34626Z",
    fill: "url(#paint0_linear_426_1122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_426_1122",
    x1: 20.9103,
    y1: 15.7329,
    x2: -0.607615,
    y2: 8.80683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10E875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03766A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowFilled);
export default __webpack_public_path__ + "static/media/rightArrowFilled.9f0d4a55cb0fb53f06285cea97cfb72e.svg";
export { ForwardRef as ReactComponent };